import { MailX } from "lucide-react";
import { LuSearch } from "@/Components/Icons/Icons";
import { parsePhoneNumberFromString } from "libphonenumber-js";

export default {
  row1: [
    {
      column: "column1",
      columnWidth: "48%",
      rows: {
        row1: [
          {
            name: "exportEntityType",
            label: "Type",
            component: "dropdown",
            width: "100%",
            endIconName: "LuChevronDown",
            defaultValue: "job1",
            options: [
              { label: "Customer", value: "Customer" },
              { label: "Transporter", value: "Transporter" },
              { label: "Forwarding Agent", value: "Forwarding Agent" },
            ],
            placeholder: "Customer",
            required: true,
          },
        ],
        row2: [
          {
            name: "exportEntityName",
            label: "Name",
            component: "text-field",
            type: "autocomplete",
            icon: LuSearch,
            width: "100%",
            endpoint: "getCustomers",
            required: true,
            autofillTargets: {
              exportEntityAddress: "address",
              exportEntityCountry: "country",
              exportEntityState: "state",
              exportEntityCity: "city",
              exportEntityPostalCode: "pincode",
              exportEntityAddressLine: "addressLine",
            },
            endPointWithId: "getCustomersAddress",
          },
        ],
        row3: [
          {
            name: "exportEntityCountry",
            label: "Country",
            component: "text-field",
            width: "100%",
            type: "autocomplete",
            endpoint: "getCountry",
            icon: LuSearch,
            linkedValue: "exportEntityCountry",
          },
        ],
        row4: [
          {
            name: "exportEntityState",
            label: "State/Province",
            component: "text-field",
            width: "100%",
            type: "autocomplete",
            endpoint: "getState",
            icon: LuSearch,
            useLinkedValue: "exportEntityCountry",
            linkedValue: "exportEntityState",
          },
        ],
        row5: [
          {
            name: "exportEntityContactPerson",
            label: "Contact Person",
            component: "text-field",
            iconName: "Search",
            width: "100%",
          },
        ],
        row6: [
          {
            name: "exportEntityAddress",
            label: "Address",
            component: "dropdown",
            width: "100%",
            endIconName: "LuChevronDown",
            iconColor: "gray-400",
            type: "autocomplete",
            autofillTargets: {
              exportEntityAddressLine: "addressLine",
              //   exportEntityCountry: "country",
              // exportEntityState: "state",
              // exportEntityCity: "city",
              // exportEntityPostalCode: "pincode",
            },
          },
        ],
        row7: [
          {
            name: "exportEntityAddressLine",
            component: "textarea",
            disabled: true,
            width: "100%",
            height: 120,
            sx: {
              borderRadius: "8px",
              marginTop: "5px",
            },
            defaultValue: "123 Dummy Street, Example City",
            py: 2,
          },
        ],
      },
    },
    {
      column: "colum2",
      columnWidth: "48%",
      rows: {
        row1: [
          {
            name: "exportEntityCity",
            label: "City",
            component: "text-field",
            styles: {
              mt: 1,
            },
            width: "100%",
            type: "autocomplete",
            endpoint: "getCity",
            icon: LuSearch,
            dependsOn: "exportEntityState",
            useLinkedValue: "exportEntityState",
          },
        ],
        row2: [
          {
            name: "exportEntityPostalCode",
            label: "Postal Code",
            component: "text-field",
            width: "100%",
          },
        ],
        row3: [
          {
            name: "exportEntityTelephone",
            label: "Telephone",
            component: "text-field",
            width: "100%",
            regex: "^\\+?[1-9]\\d{7,14}$",
            regexMessage: "Please enter a valid Telephone Number(eg:15degit)",
            maxLength: 15,
          },
        ],
        row4: [
          {
            name: "exportEntityFax",
            label: "Fax",
            component: "text-field",
            width: "100%",
            type: "phone",
            regex: "^[0-9]{10}$",
            regexMessage: "Please enter a valid Fax number(eg:10degit)",
            maxLength: 10,
          },
        ],
        row5: [
          {
            name: "exportEntityEmail",
            label: "Email",
            component: "text-field",
            width: "100%",
            regex: "^[^@\\s]+@[^@\\s]+\\.[^@\\s]+$",
            regexMessage: "Please enter a valid email(eg:Tri@gmail.com)",
          },
        ],
        row6: [
          {
            name: "exportEntityMobile",
            label: "Mobile",
            component: "text-field",
            type: "phone",
            width: "100%",
            regex: "^[0-9]{10}$",
            regexMessage: "Please enter a valid mobile number(eg:10degit)",
            maxLength: 10,
          },
        ],
      },
    },
  ],
};
